import axios from 'axios';
import { SCHEDULING_MIDDLEWARE_ENDPOINTS } from '../util/constants/scheduling-middleware-endpoints.const';
import { buildEndpoint } from '../util/endpoint';

const BASE_URL = `${process.env.PROXY_URL}/api/${process.env.SCHEDULING_MIDDLEWARE_PROXY_PATH}/v1`;

export interface EvaluationReasons {
  id: number;
  descricao: string;
  flagAtivo: boolean;
  versao: number;
  usuarioLogado: string;
  orgaoLdapUsuarioLogado: string;
  ordem: number;
}

export interface EvaluationCount {
  negativas: number;
  positivas: number;
  idServico: number;
}

export interface Reasons {
  idMotivo: number;
}

export interface RequestEvaluation {
  idServico: string;
  avaliacao: number;
  comentario?: string;
  motivos?: Reasons[];
}

export async function getEvaluationReasons(): Promise<EvaluationReasons[]> {
  try {
    const response = await axios.get(
      `${BASE_URL}/${SCHEDULING_MIDDLEWARE_ENDPOINTS.GET_REASONS}`
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao buscar motivos de avaliação:', error);
    throw new Error('Não foi possível carregar os motivos de avaliação');
  }
}

export async function getEvaluationCount(
  externalId: string
): Promise<EvaluationCount> {
  try {
    const url = buildEndpoint(
      `${BASE_URL}/${SCHEDULING_MIDDLEWARE_ENDPOINTS.GET_SERVICE_COUNT}`,
      {
        externalId,
      }
    );

    const response = await axios.get(url);

    return response.data;
  } catch (error) {
    console.error('Erro ao buscar contagem de avaliação:', error);
    throw new Error('Não foi possível carregar as contagens de avaliação');
  }
}

export async function addEvaluation(body: RequestEvaluation): Promise<void> {
  try {
    await axios.post(
      `${BASE_URL}/${SCHEDULING_MIDDLEWARE_ENDPOINTS.EVALUATE}`,
      body
    );
  } catch (error) {
    console.error('Erro ao adicionar avaliação:', error);
    throw new Error('Não foi possível adicionar a avaliação');
  }
}
